export interface IValidation {
    alias: boolean,
    donationStartDate: boolean,
    donationEndDate: boolean,
}
